import { Component } from 'react'

import { apiRequest } from '../../main/services/api'
import { decodeQueryString } from '../queryString'
import { redGreenGradient } from '../shared/gradients'
import BarChart from './barChart'
import MenuNew from './components/redesign/Menu'
import Menu from './menu'
import { CryptoTileTicker, PageType, TimeFrames } from './types'

interface CryptoPerformanceProps {
  rows: Record<CryptoTileTicker, number>
}

class CryptoPerformance extends Component<CryptoPerformanceProps> {
  declare refreshInterval: number

  state = {
    rows: this.props.rows,
  }

  componentDidMount() {
    this.refreshInterval = window.setInterval(async () => {
      const data = await apiRequest(`/api/crypto_perf.ashx${window.location.search}`)
      if (data) {
        this.setState({ rows: data })
      }
    }, 30 * 1000)
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval)
  }

  render() {
    var view = decodeQueryString()['v'] || '1'
    var kv = { d: 1, w: 2, m: 3, mtd: 8, q: 4, hy: 5, y: 6, ytd: 7 }
    var vk: Record<string, keyof typeof kv> = {}
    Object.keys(kv).forEach((key: any) => {
      vk[kv[key as keyof typeof kv].toString()] = key
    })

    var timeframes: TimeFrames<keyof typeof kv> = {
      link: (key) => '/crypto_performance.ashx?v=' + kv[key],
      onClick: () => {},
      active: vk[view],
      timeframes: [
        { key: 'd', value: 'D', title: 'Day' },
        { key: 'w', value: 'W', title: 'Week' },
        { key: 'm', value: 'M', title: 'Month' },
        { key: 'mtd', value: 'MTD', title: 'Month to Date' },
        { key: 'q', value: 'Q', title: 'Quarter' },
        { key: 'hy', value: 'HY', title: 'Half Year' },
        { key: 'y', value: 'Y', title: 'Year' },
        { key: 'ytd', value: 'YTD', title: 'Year To Date' },
      ],
    }

    var rows = Object.keys(this.state.rows)
      .map((key) => ({
        label: key,
        value: this.state.rows[key as CryptoTileTicker],
      }))
      .sort((a, b) => b.value - a.value)

    const isRedesignEnabled = FinvizSettings.hasRedesignEnabled
    const MenuComponent = isRedesignEnabled ? MenuNew : Menu
    return (
      <div className="futures forex flex flex-col">
        <MenuComponent activePage={PageType.Performance} timeframes={timeframes} />
        <div className="perf-chart-container">
          <div className="bar-chart-wrapper">
            <BarChart
              width={740}
              data={rows}
              onClick={() => {}}
              period={vk[view]}
              {...(isRedesignEnabled && { gradient: redGreenGradient })}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default CryptoPerformance
